import React, { useContext } from 'react';
import cn from 'classnames';
import { getDataTestId, createPaddingStyle } from '../../../../shared/esm';
import { SystemMessageContext } from '../../Context.js';

var styles = {"component":"system-message__component_1hmta"};
require('./index.css');

var DEFAULT_PADDING = { bottom: 12 };
var Caption = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.padding, padding = _b === void 0 ? DEFAULT_PADDING : _b;
    var dataTestId = useContext(SystemMessageContext).dataTestId;
    return (React.createElement("span", { className: cn(styles.component, className), "data-test-id": getDataTestId(dataTestId, 'caption'), style: createPaddingStyle(padding) }, children));
};

export { Caption };
